import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAnalyticsTrack } from '@/features/amplitude'
import { TextColors, TypographyStyles } from '@/styles'
import { Button, Card, CardColors, Text } from '@/ui'

export const PayrollCard = () => {
  const navigate = useNavigate()
  const track = useAnalyticsTrack()

  useEffect(() => {
    track('viewed payroll upsell card')
  }, [track])

  const handleGetStarted = () => {
    track('clicked payroll upsell card button')
    navigate('/payroll/welcome')
  }

  return (
    <Card
      color={CardColors.EMPHASIS}
      className="bg-green mobile-squared-corners bg-[url('https://heard-images.s3.amazonaws.com/assets/arrow-left.svg')] bg-no-repeat bg-fixed bg-[position:190px_100%]"
    >
      <div className="flex flex-col gap-4">
        <Text color={TextColors.WHITE} variant={TypographyStyles.H2}>
          Did you know you could run payroll with Heard?
        </Text>

        <Text color={TextColors.WHITE}>
          Heard partners with Gusto so you can pay yourself, employees, and
          contractors in minutes. Keep your practice&apos;s finances in one
          place.
        </Text>

        <Button variant="secondary" onClick={handleGetStarted}>
          Get started
        </Button>
      </div>
    </Card>
  )
}
